import { render, staticRenderFns } from "./EasterEggComponent.vue?vue&type=template&id=28638559&"
import script from "./EasterEggComponent.vue?vue&type=script&lang=ts&"
export * from "./EasterEggComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EasterEggComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports